import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useAdditionalFiltersSection from './useAdditionalFiltersSection';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const AdditionalFilters = () => {
  const {
    items,
    selectedValues,
    isAllSelected,
    isIndeterminate,
    toggle,
    toggleAll,
    isExcludedEnabled,
    onChangeExclude,
  } = useAdditionalFiltersSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.AdditionalFilters }
      dataTest="additionalFiltersSection"
      header={ (
        <FilterSectionHeader
          title="ADDITIONAL FILTERS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="additionalFiltersAllCheckbox"
            />
          ) }
          rightSlot={ (
            <Checkbox
              checked={ isExcludedEnabled }
              onChange={ onChangeExclude }
              dataTest="additionalFiltersExcludedCheckbox"
              label="Exclude selected"
            />
          ) }
        />
      ) }
    >
      { items.map((item) => (
        <Checkbox
          key={ item.value }
          label={ item.name }
          checked={ selectedValues.includes(item.value) }
          onChange={ () => toggle(item.value) }
          dataTest={ `checkbox-additionalFilters-${ item.value }` }
          className={ styles.checkbox }
        />
      )) }
    </FilterSection>
  );
};

export default AdditionalFilters;
